var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckRound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9.785A14.456 14.456 0 0015 .263c-1.371.02-2.676.2-3.915.537-1.238.338-2.41.835-3.515 1.49a15.419 15.419 0 00-2.993 2.302c-.89.88-1.658 1.873-2.303 2.978A14.932 14.932 0 00.785 11.1 14.456 14.456 0 00.263 15c.02 1.371.2 2.676.537 3.915.338 1.238.835 2.41 1.49 3.515a15.422 15.422 0 002.302 2.993 14.29 14.29 0 002.978 2.303 14.93 14.93 0 003.53 1.489c1.25.348 2.55.522 3.9.522 1.371-.02 2.676-.2 3.915-.537a14.187 14.187 0 003.515-1.49 15.418 15.418 0 002.993-2.302 14.29 14.29 0 002.303-2.978 14.932 14.932 0 001.489-3.53c.348-1.25.522-2.55.522-3.9-.02-1.371-.2-2.676-.537-3.914a14.189 14.189 0 00-1.49-3.516 15.417 15.417 0 00-2.302-2.993 14.288 14.288 0 00-2.978-2.303A14.93 14.93 0 0018.9.785zm2.991 12.223a1.637 1.637 0 00-2.035-2.565l-7.648 6.068-2.336-2.39A1.637 1.637 0 007.53 16.41l3.368 3.446c.586.6 1.531.66 2.189.139l8.804-6.987z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckRound);
export default __webpack_public_path__ + "static/media/check-round.f3fefc4e.svg";
export { ForwardRef as ReactComponent };